import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3848000f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block","width":"100px"} }, "模版名称：", -1))
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_4 = { class: "current-department" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_member_title = _resolveComponent("app-member-title")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_departmental_structure = _resolveComponent("departmental-structure")!
  const _component_departmental_member = _resolveComponent("departmental-member")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_batch_upload = _resolveComponent("batch-upload")!
  const _component_save_template = _resolveComponent("save-template")!
  const _component_quota_mange = _resolveComponent("quota-mange")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { class: "utils__pageContainer" }, {
      title: _withCtx(() => [
        _createVNode(_component_app_member_title, { routes: _ctx.routes }, null, 8, ["routes"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              (_ctx.query.type !== 'edit')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_a_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          size: "middle",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.batchUpload('upload')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("批量上传")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          size: "middle",
                          loading: _ctx.exporting,
                          disabled: _ctx.exporting,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onExport($event)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("批量导出")
                          ]),
                          _: 1
                        }, 8, ["loading", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          size: "middle",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toPage('main.staff.template_list')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("模版列表")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          size: "middle",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toPage('main.staff.execute_log')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("执行记录")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_ctx.query.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _hoisted_2,
                      _createVNode(_component_a_input, {
                        value: _ctx.templateName,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.templateName) = $event)),
                        type: "text",
                        placeholder: "模板名称",
                        "allow-clear": "",
                        maxlength: 30
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { style: {"margin-top":"20px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 6,
                style: {"background":"rgb(0 0 0 / 3%)","margin-top":"30px","padding":"10px 0 10px 10px","max-width":"200px"}
              }, {
                default: _withCtx(() => [
                  (!_ctx.changeTemplate)
                    ? (_openBlock(), _createBlock(_component_departmental_structure, {
                        key: 0,
                        ref: "departmentMenu",
                        "with-default": "",
                        onChangeDepartment: _ctx.onSetDepartment
                      }, null, 8, ["onChangeDepartment"]))
                    : (_openBlock(), _createBlock(_component_departmental_member, {
                        key: 1,
                        "member-list": _ctx.memberList,
                        "current-department": _ctx.currentDepartment,
                        onBackDepartment: _ctx.backDepartment,
                        onOperateMember: _ctx.operateMember
                      }, null, 8, ["member-list", "current-department", "onBackDepartment", "onOperateMember"]))
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 18 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.templateInfo.departmentSum || '0') + "个部门，" + _toDisplayString(_ctx.templateInfo.employeeCount || '0') + "人", 1),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      shape: "round",
                      size: "middle",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.operateMember('clear')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("清空")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_a_form, {
                    ref: "formRef",
                    model: _ctx.formData
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        style: {"width":"100%"},
                        "row-key": "id",
                        columns: _ctx.tableColumns,
                        loading: _ctx.loading,
                        "data-source": _ctx.formData.loadTableData,
                        bordered: "",
                        pagination: { ..._ctx.paginationParams, pageSizeOptions: ['10', '20', '30', '50', '100'], showSizeChanger: true},
                        "show-pagination": true,
                        onChange: _ctx.handleTableChange
                      }, {
                        adjustmentAmount: _withCtx(({ record, index }) => [
                          _createVNode(_component_a_form_item, {
                            name: ['loadTableData', index, 'adjustmentAmount'],
                            rules: [{ validator: _ctx.validatePass, trigger: ['change', 'blur'] }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: record.adjustmentAmount,
                                "onUpdate:value": ($event: any) => ((record.adjustmentAmount) = $event),
                                placeholder: "请输入",
                                onBlur: ($event: any) => (_ctx.editAvailableAmount(record, index))
                              }, null, 8, ["value", "onUpdate:value", "onBlur"])
                            ]),
                            _: 2
                          }, 1032, ["name", "rules"])
                        ]),
                        action: _withCtx(({ record }) => [
                          (_ctx.quotaType != 'general')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.quotaMange(record)), ["prevent"])
                                }, "定期额度管理", 8, _hoisted_5),
                                _hoisted_6
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.operateMember('delete', record)), ["prevent"])
                          }, "删除", 8, _hoisted_7)
                        ]),
                        _: 1
                      }, 8, ["columns", "loading", "data-source", "pagination", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_button, {
                      style: {"margin-right":"40px"},
                      type: "primary",
                      shape: "round",
                      size: "middle",
                      onClick: _ctx.saveTemplate
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存模版")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.query.type !== 'edit')
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          shape: "round",
                          size: "middle",
                          onClick: _ctx.execute
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("执行")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    (_ctx.uploadVisible)
      ? (_openBlock(), _createBlock(_component_batch_upload, {
          key: 0,
          "template-id": _ctx.templateId,
          onHandleCancel: _ctx.handleCancel
        }, null, 8, ["template-id", "onHandleCancel"]))
      : _createCommentVNode("", true),
    (_ctx.saveTemplateVisible)
      ? (_openBlock(), _createBlock(_component_save_template, {
          key: 1,
          onClose: _ctx.close,
          onHandleOk: _ctx.handleOk
        }, null, 8, ["onClose", "onHandleOk"]))
      : _createCommentVNode("", true),
    (_ctx.quotaMangeVisible)
      ? (_openBlock(), _createBlock(_component_quota_mange, {
          key: 2,
          "row-detail": _ctx.rowDetail,
          onComplete: _ctx.complete
        }, null, 8, ["row-detail", "onComplete"]))
      : _createCommentVNode("", true)
  ], 64))
}